import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable()
export class MonthsProvider {
    months = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
    ];
    constructor() {}

    returnMonths(object, _year = "0") {
        const months = [];
        const years = [];
        const current_year = moment().format("YYYY");
        let number = null;
        for (const a of object) {
            const pre = moment(a.date, "YYYY/MM/DD");
            const year = pre.format("YYYY");
            const check = pre.subtract(1, "months");
            const date = check.format("M") !== "12" ? check.format("M") : "0";
            if (!years.find((years) => years === year)) {
                years.push(year);
            }
            if (a.number) {
                number = a.number;
            }
            if (_year === "0") {
                if (months.find((months) => months.code === date)) {
                } else {
                    months.push({
                        code: date,
                        month: this.months[date],
                        year,
                        cod: a.codBarra ? a.codBarra : null,
                        link: a.link ? a.link : null,
                        number,
                        date: pre,
                    });
                }
            } else {
                if (_year === year) {
                    if (months.find((months) => months.code === date)) {
                    } else {
                        months.push({
                            code: date,
                            month: this.months[date],
                            year,
                            cod: a.codBarra ? a.codBarra : null,
                            link: a.link ? a.link : null,
                            number,
                            date: pre,
                        });
                    }
                }
            }
        }
        return [months, years];
    }

    finder(object) {
        const result = [];
        for (const a of object) {
            result[a.code] = a;
        }
        return result;
    }

    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
}



// WEBPACK FOOTER //
// ./src/providers/months/months.ts